import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';

export const MainNavItem = (props) => {

  const { nav, classes, selected, displayNode, iconSize } = props;
  const IconComponent = nav.img;
  const aId = nav.id || `nav-menu-${(nav.title || 'default')}`.toLowerCase().replace(' ', '-').replace('/', '');
  let { path } = nav;
  if (nav.useSelectedAccount) {
    path = `${path}?displayNode=${displayNode}`;
  }

  return(
    <ButtonBase
      className={classNames(classes.navMenuItem, selected === nav.path && classes.selectedItem)}// classes.navButton}
      component={React.forwardRef((propers, ref) => <NavLink {...propers} innerRef={ref}/>)} to={path}
      id={aId}
    >
      {/* Below will keep the full nav item w/ darker background color when selected */}
      <IconComponent
        title={nav.alt}
        fill="currentColor"
        height={iconSize}
        width={iconSize}
      />
      <Typography style={{ marginLeft: 24, textAlign: 'left' }} className={ selected === nav.path ? classes.selectedNavText : classes.navText}>
        {nav.title}
      </Typography>
    </ButtonBase>
  )
};

MainNavItem.propTypes = {
  nav: PropTypes.object,
  classes: PropTypes.object,
  iconSize: PropTypes.number,
  selected: PropTypes.string,
  displayNode: PropTypes.string,
};

